export const en = {
  globals: {
    save: "Save",
    submit: "submit",
    back: "back",
    select: "Select",
    serialNo: "S.No",
    title: "Title",
    description: "Description",
    price: "Price",
    status: "Status",
    actions: "Actions",
    name: "Name",
    normalCred: "Normal Credits",
    highlightedCred: "Highlighted Credits",
    Yes: "Yes",
    No: "No",
    View: "View",
    Delete: "Delete",
    Accept: "Accept",
    Reject: "Reject",
    Cancel: "Cancel",
    All: "All",
  },
  auth: {
    emailId: "Email Address",
    password: "Password",
    remember: "Remember me",
    forgotPassword: "Forgot Password",
    oldPass: "Old Password",
    confmPas: "Confirm Password",
    otpVerification: "OTP Verification",
    verify: "Verify",
    resendOtp: "Resend Otp",
    login: "Login",
    resendPass: "Reset Password",
    editProfile: "Edit Profile",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone Number",
    enterValidEmail: "Please enter email address",
    enterEmail: "Enter Email Address",
    backToLogin: "Back to Login",
    enterSend: "Please enter otp send to your email address",
    enterOTP: "Enter OTP",
    resendOTP: "Resent OTP",
    strongPass: "Choose strong password for your account",
    newPass: "New Password",
    passwordReset: "Password reset successfully",
    confrmPassRequired: "Confirm password is required.",
    passNotMatch: "Passwords must match",
    newPassRequired: "New password is required",
    passLength:
      "Password must be at least 8 characters long and include 1 uppercase, 1 lowercase, and 1 special character.",
    changePass: "Change Password",
    confirmNewPass: "Confirm New Password",
    mangeProfile: "Manage Profile",
    currenPasRequired: "Current password is required",
    notSameasOld: "New password can't be same as old password",
    passwardShouldMatch: "Passwords should match",
    passChanged: "Password changed successfully",
    myProfile: "My Profile",
    Logout: "Logout",

    //.............................................................................
    subServiceCharLen_min: "Sub Service name must be at least 2 characters",
    subServiceCharLen_max: "Sub Service name must not exceed 50 characters",
    priceRequired: "Price is required",
    descriptionLimit: "Description must not exceed 500 characters",
    arabicDescriptionLimit:
      "Description (Arabic) must not exceed 500 characters",
    failedToLoad: "Failed to load categories",
    requiredFeild: "This field is required",
    faildToLoad: "Failed to load Service",
    serviceNotFound: "Service not found",
    enabledService: "Service enabled successfully",
    disabledService: "Service disabled successfully",
    faildeServiceStatus: "Failed to update service status",
    succesfullServiceUpdate: "Service updated successfully",
    addService: "Service added successfully",
    deleteService: "Services deleted successfully",
    updatedSubCategory: "Sub category updated successfully",
    addedSubCategory: "Sub category added successfully",
    failedToLoadSubCategory: "Failed to load subcategories",
    enabledSubCategory: "Subcategory enabled successfully",
    disabledSubCategory: "Subcategory disabled successfully",
    failToUpdate: "Failed to update category status",
    successfullSubCatDeletion: "Subcategory deleted successfully",
    noDataFound: "No data found",
    addedCategory: "Category added successfully",
    updatedCategory: "Category updated successfully",
    deleteCategory: "Category deleted successfully",
    enabledCategory: "Category enabled successfully",
    disbaledCategory: "Category disabled successfully",
    requiredImage: "image is required",
    imageFormat: "Please upload the image in the JPG, JPEG or PNG format",
    confirmation: "Are you sure to delete this category",
  },
  main: {
    freeLancerPortfolio: "Freelancer Portfolio",
    manageCategories: "Manage Categories",
    ManageEmployer: "Manage Employers",
    export: "Export",
    AddCategory: "Add Category",
    Address: "Address",
    totalTasks: "Total Tasks",
    manageTasks: "manageTasks",
    employerDetail: "Employer Detail",
    personalDetail: "Personal Details",
    generalDetail: "General Details",
    taskList: "Task List",
    Image: "Image",
    phone: "Phone Number",
    rejectionReason: "Rejection Reason",
    email: "Email Id",
    employerTaskList: "Employer Task List",
    editEmployer: "Edit Employer",
    uploadImage: "Upload Image",
    firstName: "First Name",
    lastName: "Last Name",
    manageFreelancer: "Manage Freelancer",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    totalJobs: "Total Jobs",
    comJobs: "Completed Jobs",
    totalEarning: "Total Earnings",
    AccountStatus: "Account Status",
    freelancerDetail: "Freelancer Detail",
    workHistory: "Work History",
    Skills: "Skills",
    Documents: "Documents",
    civilId: "Civil Id",
    Approve: "Approve",
    Reject: "Reject",
    selectStatus: "Select Status",
    editFrancer: "Edit Freelancer",
    manageRefund: "Manage Refunds",
    managePayment: "Manage Payment",
    manageSubadmin: "Manage Sub-Admin",
    manageAnalytic: "Manage Analytics",
    manageRevenue: " Report & Disputes",
    manageNotification: "Manage Notifications",
    manageReview: "Manage Reviews",
    manageCms: "Manage CMS",
    Refunds: "Refunds",
    pendingReq: "Pending Request",
    completedReq: "Completed Request",
    Category: "Category",
    dateTime: "Date & Time",
    Amount: "Amount",
    refundDetail: "Refund Detail",
    refundReqDetail: "Refund Request Details",
    employerName: "Employer Name",
    employerEmail: "Employer email",
    employerPhone: "Employer Phone",
    freelancerName: "Freelancer Name",
    freelancerEmail: "Freelancer email",
    freelancerPhone: "Freelancer Phone",
    subService: "Sub Service",
    adOns: "Ad-Ons",
    refundStatus: "Refund Status",
    Details: "Details",
    mangeRoles: "Manage Roles",
    addSubAdmin: "Add Sub-Admin",
    addRole: "Add Role",
    editRole: "Edit Role",
    addEdit: "Add/Edit",
    moduleName: "Module Name",
    roleName: "Role Name",
    editSubAdmn: "Edit Sub-Admin",
    Role: "Role",
    selectRole: "Select Role",
    aday: "A day",
    aweek: "A week",
    amonth: "A month",
    ayear: "A year",
    Resolved: "Resolved",
    Reply: "Reply",
    addReply: "Add Reply",
    addNotification: "Add Notification",
    selectType: "Select Type",
    customerSupport: "Contact Support",
    aboutUs: "About Us",
    privacyPolicy: "Privacy Policy",
    Legal: "Legal",
    aboutUsEng: "About us (English)",
    aboutUsAr: "About us (Arabic)",
    privacyEng: "Privacy Policy (English)",
    privacyAr: "Privacy Policy (Arabic)",
    legalEng: "Legal (English)",
    legalAr: "Legal (Arabic)",
    rating: "rating",
    review: "Review",
    totalEmployer: "Total Employers",
    totalFreelancer: "Total Freelancers",
    activeTask: "Active Tasks",
    closedTask: "Closed Tasks",
    Tasks: "Tasks",

    //................................
    sort: "Sort",
    createdAt: "Created At",
    subServices: "Sub Services",
    view: "View",
    manageSubServices: "Manage Sub Services",
    addSubServices: " Add Sub Service",
    Detail: "Category Details",
    categoryImg: "Category Image",
    categoryName: "Category Name",
    categoryDetail: "Category Details",

    serviceName: "Service Name",
    startingPrice: "Starting Price",
    AddOns: "Add-Ons",
    AdOns: "Ad-Ons",
    add: "Add",
    servicesName: "Services Name",
    Manage: "Manage",
    serviceDetails: "Service Details",
    englishAdOn: "Add-On Name (English)",
    arabicAdOn: "Add-On Name (Arabic)",
    cancel: "Cancel",
    update: "Update",
    english: "English",
    arabic: "Arabic",
    noDataFound: "No data found",
    updateAdOn: "Update Add-Ons",
    addAddOn: "Add Add-Ons",
    basePrice: "Base Price",
    subServiceDetails: "Sub Service Details",
    subServiceName: "Sub Service Name",
    // managePayment:"Manage Payments",
    managePaymentDetail: "Total Commision Recieved",
    taskDetail: "Task Detail",
    employerDetails: "Employer Detail",
    freelanceDetail: "Freelancer Detail",
    paymentMode: "Payment Method",
    date: "Date",
    status: "Status",
    taskPrice: "Task Price",
    createdDate: "Created Date",
  },

  dashboard: {
    dashboard: "Dashboard",
  },
  user: {
    Actions: "Actions",
    Credits: "Credits",
    AccountStatus: "Account Status",
    Email: "Email",
    PhoneNo: "Phone No",
    Name: "Name",
    SNo: "S.No",
    ManageUsers: "Manage Users",
    ExportCsv: "Export CSV",
    SearchHere: "Search...",
    Showing: "Showing",
    items: "items",
    AddCredits: "Add Credits",
    HighlightedCredits: " Highlighted Credits",
    NormalCredits: "Normal Credits",
    ViewUserProfile: "View User Profile",

    //.........................................................
    serviceName: "Enter Service Name",
    startingPrice: "Enter Starting Price",
    enterDescription: "Enter Description",
    deleteConfirmation: "Are you sure to delete this Services",
    update: "Update",
    enterName: "Enter Add-On Name",
    enterPrice: "Enter Price",
    selectServices: "Select Service",
    enterCategoryName: "Enter Category Name",
    enterSubServiceName: "Enter Sub Service Name",
    subServiceNameArabic: "Sub Service Name (Arabic)",
    subServiceNameEnglish: "Sub Service Name (English)",

    enterBasePrice: "Enter Base Price",
    enterServiceName: "Enter Service Name",
    enterStartingPt: "Enter Starting Price",
  },

  error: {
    required: "This field is required",
    validation1: "Please select a valid video",
    maxValidation: "Maximum 80 character are allowed",
    minValidation: "Minimum 3 characters are required",
    noData: "No results found",
    titlereq: "Title is required",
    descReq: "Description is required",
    noFaq: "No faq's listing found",
    emailReq: "Email is required!",
    firstReq: "First name is required",
    lastReq: "Last name is required",
    phoneReq: "Phone number is required",
    minPhone: "Phone number must be at least 6 digits",
    maxPhone: "Phone number must be at least 16 digits",
    subAdminCreated: "Sub-admin created successfully",
    subAdminUpdate: "Sub-admin updated successfully",
    userUpdate: "User updated successfully",
    statusUpdate: "Status updated successfully",
    subAdminDel: "Sub-admin deleted successfully",
    userDel: "User deleted successfully",
    max100: "Maximum 100 character are allowed",
    max250: "Maximum 250 character are allowed",
    max500: "Maximum 500 character are allowed",
    catAdd: "Category added successfully",
    catUpdate: "Category updated successfully",
    settingUpdate: "Settings updated successfully",
    faqAdd: "FAQ added successfully",
    faqDel: "FAQ deleted successfully",
    cmsUpdate: "CMS updated successfully",
    messageReq: "Message is required",
    notiAdd: "Notification added successfully",
    notiDel: "Notification deleted successfully",
    logutReq: "Are you sure, you want to logout?",
    validphone: "Please enter a valid phone number",
    warnEmployee: "Are you sure to delete this employer",
    freelancerDelete: "Freelancer Deleted successfully",
    warnFreelancer: "Are you sure to delete this freelancer",
    otpSent: "OTP sent successfully",
    passRequired: "Password is required",
    validPass: "Please enter valid password",
    subAdminDeactivated: "Subadmin deactivated successfully",
    subAdminActivated: "Subadmin activated successfully",
    tryAgain: "Please try again",
    subAdminDeleted: "Subadmin deleted successfully",
    SubAdminWarn: "Are you sure to delete this sub-admin",
    roleUpdated: "Role status updated successfully",
    roleWarn: "Are you sure to delete this role",
    roleUUpdate: "Role update successfully",
    addAdded: "Role added successfully",
    roleNameReq: "Role Name is required",
    minTwo: "Minimum 2 characters are required",
    validEmail: "Please enter a valid email address",
    subAdminUpdated: "Sub admin updated successfully",
    subAdminAdded: "Sub admin added successfully",
    imageValidation: "Please upload the image in the JPG, JPEG or PNG format",
    pleaseSelectRole: "Please select a role",
    contactUpdated: "Contact detail updated successfully",
    privacyUpdated: "Privacy Policy updated successfully",
    aboutUpdated: "About Us updated successfully",
    termsUpdated: "Legal updated successfully",
    //
    categoryName: "Category name is required",
    catLimit_max: "Category name must be at least 2 characters",
    catLimit_min: "Category name must not exceed 50 characters",
    catName_Arabic: "Category name (Arabic) is required",
    minArabicChar_cat: "Category name (Arabic) must be at least 2 characters",
    descriptionLimit_max: "Description must not exceed 500 characters",
    ArabicDescriptionLimit_max:
      "Description (Arabic) must not exceed 500 characters",
  },
};
